import { render } from "./LabelsMenu.vue?vue&type=template&id=6fcd0224"
const script = {}

import "./LabelsMenu.vue?vue&type=style&index=0&id=6fcd0224&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__